import { useAuth } from "@features/auth/auth";
import { createFileRoute, Navigate, Outlet } from "@tanstack/react-router";
import { Loader } from "@ui/loader/loader";

export const Route = createFileRoute("/login/_guest")({
	component: GuestLayout,
});

function GuestLayout() {
	const { isAuthenticated, isLoading } = useAuth();
	if (isLoading) {
		return <Loader size="xl" color="accent" wrap />;
	}

	if (isAuthenticated) {
		return (
			<Navigate
				search={{
					search: "",
					startDate: "",
					endDate: "",
					page: 1,
					filterStatus: "",
					filters: {},
					tab: "single",
				}}
				to="/applications"
				replace
			/>
		);
	}

	return <Outlet />;
}
